export type PatientDuplicateSummary = {
  firstName: string;
  lastName: string;
  email: string;
  dob: string;
  phone: string;
  medicareNumber: string;
  medicareIrn: string;
  ihiNumber: string;
};

export type MatchedPipeline = {
  id: string;
  label: string;
  tier: number;
  flag: boolean;
};

export const DUPLICATE_DETECTION_PIPELINE_LABELS: Record<string, string> = {
  email_exact: 'Email exact match',
  medicare_base_irn_exact: 'Medicare base + IRN exact match',
  medicare_base_irn_differs_dob_exact: 'Medicare base + IRN differs + DOB exact',
  ihi_exact: 'IHI exact match',
  otp_mobile_dob_exact: 'OTP mobile + DOB exact',
  first_last_dob_exact: 'Firstname + Lastname + DOB',
  mobile_exact_only: 'Mobile exact',
  medicare_base_only: 'Medicare base only (IRN differs)',
  first_last_only: 'Firstname + Lastname',
  dob_only: 'DOB',
};
